import fb from '../../../utils/service/fb'

export enum SIGN_IN_STEPS {
  IDLE,
  SIGN_IN_LOGIN,
  SIGN_IN_PASSWORD,
  SIGN_IN_PHONE_VERIFY,
  FORGOT_PASSWORD,
}

export type State = {
  login?: string
  type?: 'email' | 'phone'
  isNewUser?: boolean
  verifier?: fb.auth.RecaptchaVerifier
}
